import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import Metrics from "../parts/Metrics";
import Caps from "../parts/Caps";
import Approach from "../parts/Approach";
import Pillars from "../parts/Pillars";
import Invite from "../parts/Invite";

const Home = () => (
  <Frame>
    <Meta />

    {/* HERO */}
    <section className="hero">
      <div className="shell">
        <div className="layout">
          <div>
            <span className="eyebrow">Digital marketing studio</span>
            <h1>
              Brand momentum, <em>turned into</em> measurable growth.
            </h1>
            <p className="lede" style={{ marginTop: "1.5rem" }}>
              CMV Vision is a senior-led digital marketing studio. We design the strategy, run the channels, ship
              the content and measure what actually moved — for brands that want growth they can trace.
            </p>
            <div className="signature">
              <Link to="/capabilities" className="btn btn--cobalt">
                See capabilities <FiArrowRight />
              </Link>
              <Link to="/contact" className="btn btn--line">
                Start a brief
              </Link>
            </div>
          </div>

          {/* Hero visual panel — orbital marketing identity */}
          <div className="panel">
            <div className="panel-meta">
              <div className="coord">Marketing in motion · Senior-led</div>
              <div className="title">Strategy. Creative. Channels. Measurement — all under one team.</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Metrics />

    {/* CAPABILITIES */}
    <section className="band">
      <div className="shell">
        <div className="section-title">
          <div className="left">
            <span className="eyebrow">Capabilities</span>
            <h2>Nine disciplines, one accountable team.</h2>
            <p>From the first strategy sprint through to the last attribution report, every workstream is led by a senior at CMV — not subcontracted out.</p>
          </div>
          <div className="right">
            <Link to="/capabilities" className="btn btn--line">All capabilities <FiArrowUpRight /></Link>
          </div>
        </div>
        <Caps limit={6} />
      </div>
    </section>

    {/* APPROACH */}
    <section className="band band--cream">
      <div className="shell">
        <div className="section-title">
          <div className="left">
            <span className="eyebrow">Approach</span>
            <h2>A four-stage delivery rhythm.</h2>
            <p>Surprises in marketing programmes are rarely good. Our model exists to make progress visible early — and problems visible earlier.</p>
          </div>
          <div className="right">
            <Link to="/approach" className="btn btn--line">Read the approach <FiArrowUpRight /></Link>
          </div>
        </div>
        <Approach />
      </div>
    </section>

    {/* WHY US duet */}
    <section className="band">
      <div className="shell">
        <div className="duet">
          <div>
            <span className="eyebrow">Why CMV Vision</span>
            <h2>Built around outcomes — not activity reports.</h2>
            <p>
              Most marketing engagements drift because the wrong things get measured. We anchor each engagement to
              business KPIs the CFO already tracks, and report against them every month — in plain language, in writing.
            </p>
            <ul className="tick">
              <li><span className="m"><FiCheck /></span> Senior strategists on every account · no junior pass-through</li>
              <li><span className="m"><FiCheck /></span> Full-stack delivery: strategy, brand, content, paid, SEO, analytics</li>
              <li><span className="m"><FiCheck /></span> Bilingual execution in each market we run in</li>
              <li><span className="m"><FiCheck /></span> Contracted SLAs and quarterly business reviews</li>
            </ul>
            <div style={{ marginTop: "2rem" }}>
              <Link to="/studio" className="btn btn--ink">About the studio <FiArrowUpRight /></Link>
            </div>
          </div>

          <div className="stat-card">
            <div className="big">+<em>182%</em></div>
            <div className="lbl">Average lift in qualified pipeline across year-one engagements — measured incrementally, not last-click.</div>
            <div className="grid-meta">
              <div>
                <div className="k">9 capabilities</div>
                <div className="v">Under one producer</div>
              </div>
              <div>
                <div className="k">24 active brands</div>
                <div className="v">DACH · Balkans · MENA</div>
              </div>
              <div>
                <div className="k">Senior-led</div>
                <div className="v">10+ years per lead</div>
              </div>
              <div>
                <div className="k">Reported</div>
                <div className="v">In CFO language</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* PILLARS */}
    <section className="band band--soft">
      <div className="shell">
        <div className="section-title">
          <div className="left">
            <span className="eyebrow">Principles</span>
            <h2>Four commitments we put in writing.</h2>
            <p>Named clauses in every retainer. If we breach one, you have a contractual right to terminate.</p>
          </div>
        </div>
        <Pillars />
      </div>
    </section>

    <Invite />
  </Frame>
);

export default Home;
